import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { queryClient } from 'src/core/react-query';
import type { ProfileInfo } from 'src/core/types';

import axios from './axios';

export interface UseMutatePersonalInfoVariables {
  avatar?: string | null;
  department: number | null;
  job: number | null;
  location: number | null;
  manager: number | null;
}

export interface UseMutatePersonalInfoData extends ProfileInfo {}

export function useMutatePersonalInfo() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseMutatePersonalInfoData,
    AxiosError<UseMutatePersonalInfoData>,
    UseMutatePersonalInfoVariables
  >(
    (variables) => {
      const data = variables;

      return axios
        .put<UseMutatePersonalInfoData>('/posht/ashena/me/profile/', data)
        .then((res) => res.data);
    },
    {
      onError: () => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      // TODO: onMutate: () => {},
      onSettled: () => {
        queryClient.invalidateQueries('profile');
      },
      onSuccess: () => {
        enqueueSnackbar(t('operation.successful'), { variant: 'success' });
      },
    },
  );
}
